<template>
	<div>
		<!-- Label -->
		<div class="flex xs-12 xs-between">
			<label class="fs3 c6 fw6 mb1">{{ label }}</label>
		</div>
		<core-form-input
			:placeholder="$t('select_template')"
			componentName="j-base-select"
			name="selectReportType"
			:options="options"
			v-validate="'required'"
			@input="handleInput($event)"
			v-model="selected"
		/>
	</div>
</template>

<script>
import CoreFormInput from "@/modules/core/components/CoreFormInput"

export default {
	props: {
		label: String
	},
	components: {
		CoreFormInput
	},
	data() {
		return {
			selected: "",
			options: [
				{
					name:
						"1. Number of applications by five underwriting/re-underwriting, by age and sex of Insured Person",
					value: "template_01"
				},
				{
					name:
						"2. Number of applications by five underwriting/re-underwriting, by place of Residence of Insured Person",
					value: "template_02"
				},
				{
					name:
						"3. Number of applications by five Underwriting / Re-underwriting results, by whether the Insured Person is newly insured or insured through Migration",
					value: "template_03"
				},
				{
					name:
						"4. Record of applications with Premium Loading/CBE/declined status ",
					value: "template_04"
				},
				{
					name:
						"5. Total number of policies, Policy Holders and Insured Person",
					value: "template_05"
				},
				{
					name:
						"6. Number of policies by four underwriting/re-underwriting results, by age and sex of Insured Person",
					value: "template_06"
				},
				{
					name:
						"7. Number of policies by four underwriting/re-underwriting results, by place of Residence of Insured Person",
					value: "template_07"
				},
				{
					name:
						"8. Number of policies by four Underwriting / Re-underwriting results, by whether the Insured Person is newly insured or insured through Migration",
					value: "template_08"
				},
				{
					name:
						"9. Record of policies with Premium Loading/CBE",
					value: "template_09"
				},
				{
					name:
						"10. Number of policies by whether one of the Policy Holder(s) is the Insured Person",
					value: "template_10"
				},
				{
					name:
						"11. Claim counts by approved claim and rejected claim with reasons",
					value: "template_11"
				},
				{
					name: "12. Claim records",
					value: "template_12"
				},
				{
					name: "13. Premium and expense statistics",
					value: "template_13"
				},
				{
					name:
						"A1. Number of applications by five underwriting/re-underwriting, by age and sex of Insured Person",
					value: "template_a1"
				},
				{
					name:
						"A2. Number of accepted/rejected offer of customers by four Underwriting/ Re-underwriting results, by Place of Residence of Insured Person",
					value: "template_a2"
				},
				{
					name:
						"A3. Number of accepted/rejected offer of customers by four Underwriting/ Re-underwriting results, by whether the Inusred Person is newly insured through Migration",
					value: "template_a3"
				},
				{
					name:
						"A4. Number of policies expired, by four Underwriting/ Re-underwriting results, by age and sex of Insured Person",
					value: "template_a4"
				},
				{
					name:
						"A5. Number of policies expired, by four Underwriting/ Re-underwriting results, by Place of Residence of Insured Person",
					value: "template_a5"
				},
				{
					name:
						"A6. Number of policies expired, by four Underwriting/ Re-underwriting results, by whether the Insured Person is newly insured or isured through Migration",
					value: "template_a6"
				},
				{
					name:
						"A7. Number of policies effective, by four Underwriting/ Re-underwriting results, by age and sex of Insured Person",
					value: "template_a7"
				},
				{
					name:
						"A8. Number of policies effective, by four Underwriting/ Re-underwriting results, by Place of Residence of Insured Person",
					value: "template_a8"
				},
				{
					name:
						"A9. Number of policies effected, by four Underwriting/ Re-underwriting results, by whether the Insured Person is newly insured or isured through Migration",
					value: "template_a9"
				}
			]
		}
	},

	methods: {
		handleInput(value) {
			this.$emit("input", value)
		}
	}
}
</script>
